import { render } from "./pay.vue?vue&type=template&id=a945bc0e"
import script from "./pay.vue?vue&type=script&lang=js"
export * from "./pay.vue?vue&type=script&lang=js"

import "./pay.vue?vue&type=style&index=0&id=a945bc0e&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__